import { useState } from "react";
import { withAppHOC } from "../../hoc";
import {
  StyledCallbackUrl,
  StyledContentContainer,
  StyledMainAreaContainer,
} from "../../components/styled";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  Form,
  Fieldset,
  Label,
  TextInput,
  MessageBox,
  Button,
} from "../../components/FormElements";
import API from "../../api";
import { RESPONSE_STATUSES } from "../../constants";
import { getReturnUrl } from "../../utils";

const BuyerAPISettingsCreate = (props) => {
  const [state, setState] = useState({
    isLoading: false,
    responseStatus: "",
    responseMessage: "",
    name: "",
    ipAddress: "",
    callbackUrl: "",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: "",
      responseMessage: "",
    }));
    try {
      const response = await API.post("/buyer/api-settings", {
        name: state.name,
        ipAddress: state.ipAddress,
        callbackUrl: state.callbackUrl,
      });
      const { status, message } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          name: "",
          ipAddress: "",
          callbackUrl: "",
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: "",
            responseMessage: "",
          }));
          window.location.href = getReturnUrl("create");
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const renderPageHeading = () => (
    <PageHeader title="Create API Setting" showBackButton={true} />
  );

  return (
    <>
      {renderPageHeading()}
      <StyledContentContainer>
        <StyledMainAreaContainer>
          <Form
            action="#"
            method="POST"
            onSubmit={onSubmit}
            style={{ maxWidth: "500px" }}
          >
            <Fieldset>
              <Label required>Name</Label>
              <TextInput
                value={state.name}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    name: value,
                  }))
                }
                placeholder="Name"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Server IP Address</Label>
              <TextInput
                value={state.ipAddress}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    ipAddress: value,
                  }))
                }
                placeholder="Server IP Address"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Callback URL</Label>
              <TextInput
                value={state.callbackUrl}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    callbackUrl: value,
                  }))
                }
                placeholder="Callback URL"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <StyledCallbackUrl>
                {`Example : ${
                  state.callbackUrl
                    ? state.callbackUrl
                    : `https://www.yourdomain.com/recharge_callback`
                }?status=[TRANSACTION_STATUS]&txn_id=[TRANSACTION_ID]&operators_id=[OPERATOR_ID]&customer_account_number=[CUSTOMER_ACCOUNT_NUMBER]&customer_mobile=[CUSTOMER_MOBILE_NUMBER]&amount=[AMOUNT]&payment_time=[PAYMENT_TIME]&ref_number=[YOUR_REF_NUMBER]`}
              </StyledCallbackUrl>
            </Fieldset>
            {state.responseStatus && state.responseMessage && (
              <Fieldset>
                <MessageBox
                  status={state.responseStatus}
                  message={state.responseMessage}
                />
              </Fieldset>
            )}
            <Fieldset>
              <Button disabled={state.isLoading}>Create</Button>
            </Fieldset>
          </Form>
        </StyledMainAreaContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(BuyerAPISettingsCreate);
